module.exports = __webpack_public_path__ + "img/google.82a7b30a.svg";